import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageEditText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPageEditText"><Path d="M11.5 21.5H4.5V2.5H19.5V11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 21.5002V19.1668L18.75 14.9168C19.3943 14.2725 20.439 14.2725 21.0833 14.9168C21.7277 15.5612 21.7277 16.6058 21.0833 17.2502L16.8333 21.5002H14.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 6.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 10.5H11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPageEditText;
